<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add Page Category</h2>
            <ElementCategories category_id="5" elementName="Page"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Pages',
                    to: '/pages/all'
                }, {
                    text: 'Page Category',
                    href: '#'
                }
            ],
        };
    },
};
</script>